<template>
  <div class="item-wrapper">
    <div class="bread-crumbs" style="height: 22px">
      <!-- <router-link to="/">首页</router-link>
      <template v-if="navs.length">
        <router-link v-for="nav in navs" :key="`nav-${nav.id}`" :to="`/category/${nav.path}`">{{nav.name}}</router-link>
      </template> -->
    </div>
    <div class="item-container" v-if="info">
      <!-- 商品图片 & 商品规格 -->
      <div class="pdp-top">
        <ViewItemInfo :source="info" scope="detail" @confirm="addToCart" @checkout="toBuyNow"
          @notify="showNotifyDialog" />
      </div>
      <!-- 商品详情 & 相关推荐 & 最近浏览 -->
      <div class="pdp-btm">
        <Recommend :uid="info.id" />
        <div class="item-info" v-if="info.detail && info.detail != '#N/A' && info.detail != '0'">
          <div class="item-details">
            <h3 class="item-section-header">商品详情</h3>
            <div class="item-details-text">{{ info.detail }}</div>
          </div>
          <div class="item-feature" style="display: none">
            <h3 class="item-section-header">Product Features</h3>
          </div>
        </div>
        <RecentlyViewed :uid="info.id" />
      </div>
    </div>
    <!-- 到货通知弹窗 -->
    <div class="dialog notify-dialog" v-if="notifyItem">
      <div class="mask"></div>
      <div class="dialog">
        <div class="dialog-container">
          <div class="dialog-header">
            <button class="dialog-close" @click="hideNotifyDialog">
              <span class="close-icon"></span>
            </button>
          </div>
          <div class="dialog-body">
            <ItemNotify :source="notifyItem" @confirm="sendNotify" />
          </div>
        </div>
      </div>
    </div>
    <!-- 加入购物车弹窗 -->
    <div class="dialog cart-dialog" v-if="cartInfo">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <button class="dialog-close" @click="closeCartDialog(0)">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <div class="body-main">
            <div class="item-detail">
              <h2 class="title">已加入购物车</h2>
              <div class="item-info">
                <img :src="cartInfo.info.cover" />
                <div class="pdp-detail">
                  <div class="item-name">{{ cartInfo.info.name }}</div>
                  <template v-if="Array.isArray(cartInfo.info.custom_tags) && calcIsShowCustomerTag && cartInfo.info.custom_tags">
                    <div v-for="(label, index) in cartInfo.info.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
                      {{ label }}
                    </div>
                  </template>
                  <div class="item-attr">
                    <span class="attr-name">颜色</span>:
                    <span class="attr-value">{{
                      cartInfo.info.color.name
                    }}</span>
                  </div>
                  <div class="item-attr">
                    <span class="attr-name">尺码</span>:
                    <span class="attr-value">{{
                      cartInfo.info.size.name
                    }}</span>
                  </div>
                  <div class="item-price">
                    <span class="rmb-symbol">￥</span>{{ cartInfo.info.price }}
                  </div>
                </div>
              </div>
            </div>
            <div class="cart-detail">
              <h2 class="title">订单小计</h2>
              <div class="cart-subtotal">
                <span class="rmb-symbol">￥</span>{{ cartInfo.subTotal }}
              </div>
              <button class="checkout" @click="toCheckout">立即结算</button>
              <button class="view-cart" @click="toCart">查看购物车</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <div class="dialog login-dialog" v-if="showLogin">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
        </div>
        <div class="dialog-body">
          <Login :returnUrl="returnUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recommend from "@/components/Recommend.vue";
import RecentlyViewed from "@/components/RecentlyViewed.vue";
import ViewItemInfo from "@/components/ViewItemInfo.vue";
import ItemNotify from "@/components/ItemNotify.vue";
import Login from "@/components/Login.vue";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
export default {
  name: "Detail",
  components: { Recommend, RecentlyViewed, ViewItemInfo, ItemNotify, Login },
  data() {
    return {
      // 功能基础数据
      info: null,
      // 弹窗数据
      notifyItem: null, // 到货通知 - 状态
      cartInfo: null, // 加入购物车成功
      returnUrl: "/checkout", // 登录后的跳转地址
      showLogin: false, // 是否显示登录弹窗
    };
  },
  created() {
    let ret = (this.$route.params.id || "").split("-");
    if (ret.length != 2) {
      console.warn(ret);
      this.$router.replace({ name: "Home" });
    } else {
      this.loadSource();
    }
  },
  methods: {
    //
    loadSource() {
      let [id, color] = (this.$route.params.id || "").split("-");
      api[types.GET_DETAIL](id, color)
        .then((res) => {
          if (res.data) {
            this.info = res.data;
          } else {
            console.warn(res);
            // OWHS-10096 - 【OT】后端返回商品id或color为空时判断
            setTimeout(() => this.$router.replace({ name: "Home" }), 1000)
          }
        })
        .catch((err) => {
          console.error(err);
          // OWHS-10096 - 【OT】后端返回商品id或color为空时判断
          setTimeout(() => this.$router.replace({ name: "Home" }), 1000)
        });
    },
    // 立即购买
    toBuyNow(args) {
      let { size, quantity } = args;
      let ids = `${size.id},${quantity}`;
      if (this.isLogin) {
        let params = { ids }
        api[types.CONFIRM](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?ids=${ids}&confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        // 修改登录成功跳转地址
        this.returnUrl = `/checkout?ids=${ids}`;
        this.showLoginDialog();
      }
    },
    // 加入购物车
    addToCart(args) {
      let { info, color, size, quantity } = args;
      if (this.isLogin) {
        api[types.ADD_TO_CART]({ id: size.id, quantity: quantity })
          .then((res) => {
            if (res?.code == 1) {
              this.cartInfo = res.data;
              this.cartInfo.info.cover = this.cartInfo?.info?.images[0];
              this.$store.dispatch(types.GET_CART_INFO);
              this.closeCartDialog(3000);
              //
              this.gaTrack4AddToCart({
                id: `${info.id}-${color?.id}`,
                name: info.name,
                price: info.price,
                quantity,
                category: info.category?.name,
                variant: color?.name,
              });
            }
          })
          .catch((err) => {
            console.error(err);
            // this.$message({ message: "网络异常" });
          });
      } else {
        //未登录只有本地购物车 手动校验库存不足
        let localCart = utils.getCartInfo();
        let localQuantity = Number(localCart?.list?.find(i => i.id === size.id)?.quantity || 0)
        if (Number(size.stock) < Number(quantity) + localQuantity) {
          this.$message({
            message: '库存不足',
            type: "warning"
          });
          return;
        }
        let newArgs = {
          id: size.id,
          price: info.price || "0.00",
          quantity: quantity,
        };
        utils.addToCart(newArgs, () => {
          this.$store.dispatch(types.GET_CART_INFO, () => {
            //有可能被过滤库存 需要从接口获取不能直接设置
            const cartInfo = this.$store.state.cartInfo
            this.cartInfo = {
              info: cartInfo?.list.find(i => i.id === size.id),
              subTotal: Number(cartInfo?.subTotal || 0).toFixed(2),
            };
            this.cartInfo.info.cover = this.cartInfo?.info?.images[0];
          });
          this.closeCartDialog(3000);
        });
      }
    },
    //
    gaTrack4AddToCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "add_to_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
              price: Number(info.price),
              quantity: Number(info.quantity),
              currency: "CNY",
            },
          ],
        });
      }
    },
    // 延迟一秒钟关闭加入购物车成功碳层
    closeCartDialog(time) {
      setTimeout(() => {
        this.cartInfo = null;
      }, time);
    },
    // 加入购物车成功 -> 立即结算
    toCheckout() {
      if (this.isLogin) {
        let params = {}
        api[types.CONFIRM](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        this.showLoginDialog();
      }
    },
    // 加入购物车成功 -> 去购物车
    toCart() {
      this.$router.push({ path: "/cart" });
    },
    // 显示到货通知弹窗
    showNotifyDialog(info) {
      this.notifyItem = info;
    },
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 显示登录弹窗
    showLoginDialog() {
      this.showLogin = true;
    },
    // 关闭登录弹窗
    hideLoginDialog() {
      this.returnUrl = "/checkout";
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    navs() {
      let ret = [];
      if (this.info) {
        let { gender, category } = this.info;
        ret.push({ id: gender.id, name: gender.name, path: gender.id });
        ret.push({
          id: category.id,
          name: category.name,
          path: `${gender.id}-${category.id}`,
        });
      }
      return ret;
    },
    calcIsShowCustomerTag() {
      return this.$store.state.isShowCustomerTag
    }
  },
  watch: {
    $route() {
      this.loadSource();
    },
  },
};
</script>

<style lang="scss" scoped>
.item-wrapper {
  background: #efefef;

  .bread-crumbs {
    box-sizing: border-box;
    margin: auto;
    width: calc(100% - 20px);
    max-width: 1200px;
    font-size: calc(0.6875rem * 1.6);
    line-height: 1em;
    padding: 0.5em 0;
    text-align: left;

    a {
      font-weight: 400;
      font-size: calc(0.6875rem * 1.6);
      color: #000;
      letter-spacing: 0.025em;
      overflow: hidden;
      text-decoration: none;
      cursor: pointer;
      margin-right: 4px;

      &::after {
        color: #ccc;
        content: "/";
        margin-left: 0.4em;
        display: inline-block;
      }

      &:last-child::after {
        content: "";
      }

      &:hover {
        font-weight: 400;
        color: #999;
        text-decoration: underline;
      }
    }
  }

  .item-container {
    margin-bottom: 20px;

    .pdp-top {
      box-sizing: border-box;
      margin: auto;
      width: calc(100% - 20px);
      max-width: 1200px;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -ms-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;

      & ::v-deep .item-wrapper .item-images {
        width: calc(98% - 410px);
      }

      & ::v-deep .item-wrapper .item-detail {
        width: 410px;
      }
    }

    .pdp-btm {
      border-top: 1px solid #b4b5b4;
      margin-top: 30px;
      background: #fff;

      .item-info {
        box-sizing: border-box;
        width: 85%;
        max-width: 1200px;
        padding: 0;
        margin: 0 auto;

        .item-details,
        .item-feature {
          padding: 0 0 30px;
          margin: 0 10px;

          .item-section-header {
            margin: 30px 0;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            color: #000;
          }

          .item-details-text {
            color: #000;
            font-weight: 400;
            font-size: calc(0.875rem * 1.6);
            line-height: calc(1.3rem * 1.6);
            text-align: left;
          }
        }

        .item-feature {
          ul {
            overflow: auto;
            text-align: left;

            li {
              box-sizing: border-box;
              width: calc(50% - 20px);
              font-weight: 400;
              font-size: calc(0.875rem * 1.6);
              color: #000;
              padding: 0 20px 15px 0;
              margin: 0 0 10px;
              float: left;

              div {
                font-weight: 700;
                font-size: calc(1rem * 1.6);
              }
            }

            &::after {
              clear: both;
            }
          }
        }
      }
    }
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1010;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          z-index: 1;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        display: flex;
        box-sizing: border-box;
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-header {
          .dialog-title {
            border-bottom: 1px solid #b4b5b4;
            font-weight: 400;
            font-size: calc(1.375rem * 1.6);
            color: #000;
            text-transform: uppercase;
            padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
            margin: 0 calc(1.25rem * 1.6);
            width: calc(100% - 40px);
            box-sizing: border-box;
          }
        }

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.login-dialog {
      .dialog-container {
        width: 470px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {

          // padding: 0 45px;
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              width: 75%;
            }
          }
        }
      }
    }

    &.cart-dialog {
      .mask {
        z-index: 990; //低于header1000
      }

      .dialog-container {
        position: absolute;
        top: 119px;
        left: 0;
        z-index: 991; //低于header1000
        width: 100%;
        max-width: 100%;
        min-height: 235px;
        border-radius: 0;
        transform: translate(0, 0);

        .dialog-header {
          .dialog-close {
            top: 10px;
            right: 10px;

            .close-icon {
              background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
              background-position: center center;
            }
          }
        }

        .dialog-body {
          padding: 30px 20px;

          .body-main {
            display: flex;
            width: 100%;
            max-width: 1025px;
            margin: 0 auto;

            .item-detail {
              box-sizing: border-box;
              width: 50%;
              padding-right: 10px;
              text-align: left;

              .item-info {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                img {
                  width: 120px;
                  height: 120px;
                }

                .pdp-detail {
                  margin-left: calc(1.1875rem * 1.6);

                  .item-name {
                    font-weight: 400;
                    font-size: calc(1rem * 1.6);
                    line-height: calc(1.375rem * 1.6);
                    letter-spacing: 0.025em;
                    color: #000;
                  }

                  .item-tag {
                    font-size: 10px;
                    border: 1px solid #212322;
                    padding: 0px 5px;
                    margin: 4px 0;
                    line-height: 18px;
                    color: #212322;
                    width: fit-content;
                  }

                  .item-attr {
                    text-align: left;
                    line-height: 24px;

                    .attr-name {
                      font-weight: 400;
                      font-size: calc(0.8125rem * 1.6);
                      color: #000;
                    }

                    .attr-value {
                      font-weight: 400;
                      font-size: calc(0.8125rem * 1.6);
                      color: #000;
                    }
                  }

                  .item-price {
                    font-weight: 400;
                    font-size: calc(1.125rem * 1.6);
                    line-height: 24px;
                    color: #000;
                  }
                }
              }
            }

            .cart-detail {
              box-sizing: border-box;
              width: 50%;
              padding-left: calc(3.0625rem * 1.6);
              border-left: 1px solid #b4b5b4;
              text-align: center;

              .cart-subtotal {
                font-weight: 400;
                line-height: calc(1.5rem * 1.6);
                font-size: calc(1.5rem * 1.6);
                color: #000;
              }

              .checkout {
                display: block;
                box-sizing: border-box;
                max-width: 285px;
                margin: 10px auto 0;
                cursor: pointer;
                line-height: 38px;
                padding: 0 30px;
                font-weight: 400;
                font-size: calc(0.875rem * 1.6);
                letter-spacing: normal;
                border-radius: 2px;
                text-align: center;
                text-decoration: none;
                text-transform: uppercase;
                transition: all 0.3s ease;
                color: #fff;
                background-color: #7f0019;
                border: 1px solid #7f0019;
              }

              .view-cart {
                display: block;
                line-height: calc(1.375rem * 1.6);
                font-size: calc(0.875rem * 1.6);
                font-weight: 400;
                color: #000;
                margin: 12px auto 0;
                cursor: pointer;
                text-align: center;
                background: transparent;

                &:hover {
                  text-decoration: underline;
                }
              }
            }

            .title {
              display: block;
              font-weight: 400;
              font-size: calc(1.625rem * 1.6);
              line-height: calc(1.625rem * 1.6);
              letter-spacing: 0.05em;
              margin: 0 0 25px;
              text-align: center;
              color: #000;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .item-wrapper {
    .dialog {
      &.cart-dialog {
        .dialog-container {
          top: 107px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .item-wrapper {
    background: #fff;

    .item-container {
      .pdp-top {
        width: 100%;

        & ::v-deep .item-wrapper .item-extra-mobile {
          padding: 0 10px;
        }

        & ::v-deep .item-wrapper .item-images {
          width: 100%;
        }

        & ::v-deep .item-wrapper .item-detail {
          width: 100%;
        }
      }

      .pdp-btm {
        border-top: none;

        .item-info {
          .item-feature {
            ul {
              li {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .dialog {
      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #fff;
        }
      }

      &.cart-dialog {
        .dialog-container {
          position: fixed;

          .dialog-body {
            .body-main {
              flex-direction: column;

              .item-detail {
                width: 100%;
                padding-right: 0;
                padding-bottom: 20px;

                .title {
                  font-size: 20px;
                }
              }

              .cart-detail {
                width: 100%;
                padding-left: 0;
                padding-top: 20px;
                border-left: none;
                border-top: 1px solid #b4b5b4;

                .title {
                  font-size: 20px;
                }

                .cart-subtotal {
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .item-wrapper {
    .dialog {
      &.notify-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.login-dialog {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #fff;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body ::v-deep .login-component {
            .el-form {
              width: calc(100% - 40px);
            }
          }
        }
      }
    }
  }
}
</style>
